var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 24C12.1556 24 13.4986 22.657 13.4986 21H7.50143C7.50143 22.657 8.84439 24 10.5 24ZM20.5964 16.9823C19.6908 16.0092 17.9963 14.5453 17.9963 9.75C17.9963 6.10781 15.4425 3.19219 11.9991 2.47688V1.5C11.9991 0.671719 11.3278 0 10.5 0C9.67221 0 9.00096 0.671719 9.00096 1.5V2.47688C5.55752 3.19219 3.00378 6.10781 3.00378 9.75C3.00378 14.5453 1.30925 16.0092 0.403626 16.9823C0.122376 17.2847 -0.00231134 17.6461 3.24088e-05 18C0.00518865 18.7687 0.608469 19.5 1.50472 19.5H19.4953C20.3916 19.5 20.9953 18.7687 21 18C21.0023 17.6461 20.8777 17.2842 20.5964 16.9823Z",
    fill: "#E6126A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifBell);
export default __webpack_public_path__ + "static/media/notif-bell.654d813b6e65b4a310e6bdedc3bb60bb.svg";
export { ForwardRef as ReactComponent };